import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "candidate-prompt-dialog__content" }
const _hoisted_2 = { class: "candidate-prompt-dialog__footer" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidatePromptDialog',
  props: {
    modelValue: { type: Boolean },
    title: { default: '提示' },
    message: {},
    confirmText: { default: '确认' },
    cancelText: { default: '取消' },
    showCancel: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    width: { default: '480px' }
  },
  emits: ["update:modelValue", "confirm", "cancel", "close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function handleConfirm() {
  emit('update:modelValue', false)
  emit('confirm')
}

function handleCancel() {
  emit('update:modelValue', false)
  emit('cancel')
}

function handleClose() {
  emit('update:modelValue', false)
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "candidate-prompt-dialog",
    "model-value": _ctx.modelValue,
    title: _ctx.title,
    width: _ctx.width,
    "show-close": _ctx.showClose,
    "close-on-click-modal": false,
    "close-on-press-escape": _ctx.showClose,
    "append-to-body": "",
    "align-center": "",
    "destroy-on-close": "",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showCancel)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "candidate-prompt-dialog__cancel",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          class: "candidate-prompt-dialog__confirm",
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "candidate-prompt-dialog__icon",
          "aria-hidden": "true"
        }, "!", -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "width", "show-close", "close-on-press-escape"]))
}
}

})